(function () {
  'use strict';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-card__form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(form);
  });

  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var btn = form.querySelector('button[type="submit"]');
    var span = btn && btn.querySelector('span');
    if (btn) btn.disabled = true;
    if (span) span.textContent = 'Adding…';

    var formData = new FormData();
    formData.append('id', idInput.value);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Could not add to cart');

        if (data.sections && data.sections['cart-drawer']) {
          injectCartHtml(data.sections['cart-drawer']);
        } else {
        }

        openDrawer();
        updateCartCount();

        if (span) span.textContent = 'Added!';
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (span) span.textContent = 'Add to Cart';
        }, 1800);
      })
      .catch(function (err) {
        if (btn) btn.disabled = false;
        if (span) span.textContent = 'Add to Cart';
      });
  }

  function injectCartHtml(sectionHtml) {
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var newInner = doc.querySelector('#CartDrawer');
    var oldInner = document.querySelector('#CartDrawer');
    if (newInner && oldInner) {
      oldInner.innerHTML = newInner.innerHTML;
    }
  }

  function openDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;
    cartDrawerEl.classList.remove('is-empty');
    var innerEl = cartDrawerEl.querySelector('.drawer__inner');
    if (innerEl) innerEl.classList.remove('is-empty');
    if (typeof cartDrawerEl.open === 'function') {
      cartDrawerEl.open();
    } else {
      document.body.classList.add('overflow-hidden');
      setTimeout(function () { cartDrawerEl.classList.add('animate', 'active'); });
      var overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', function () {
          cartDrawerEl.classList.remove('active', 'animate');
          document.body.classList.remove('overflow-hidden');
        }, { once: true });
      }
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        var gsCount = document.getElementById('cartCount');
        if (gsCount) { gsCount.textContent = count; gsCount.classList.toggle('is-hidden', count === 0); }
        var bubble = document.querySelector('.cart-count-bubble [aria-hidden]');
        if (bubble) bubble.textContent = count;
      })
      .catch(function () {});
  }

})();
